import React from "react";
import { Card, Grid, Typography } from '@curves/ui-base';

import ReadTextField from "@Local/Components/ReadTextField";
const ClubSectionByRead = props => {
	const { clubName, saleClubName, employeeName } = props;
	return (
		<Card>
			<Card.CardHeader
				title={
					<Typography variant="body-1" className="font-weight-900">
						店鋪教練資訊
					</Typography>
				}
				className="bg-black"
			/>
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="所屬店舖">{clubName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="販售店舖">{saleClubName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="擔當">{employeeName}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
};
export default ClubSectionByRead;
